import { createAction, props } from '@ngrx/store';

export const submitUsername = createAction(
  '[Account Activation] Submit Username',
  props<{ username: string }>()
);

export const submitUsernameSuccess = createAction(
  '[Account Activation] Submit Username Success',
  props<{
    username: string;
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    loginMethod: string | null;
    expiresIn: number | null;
    expiresAt: string | null;
    message: string | null;
  }>()
);

export const submitUsernameFailure = createAction(
  '[Account Activation] Submit Username Failure',
  props<{ error: string }>()
);

export const verifyOtp = createAction(
  '[Account Activation] Verify OTP',
  props<{ code: string }>()
);

export const verifyOtpSuccess = createAction(
  '[Account Activation] Verify OTP Success',
  props<{
    // The password-setup token the code step returns. user-management checks
    // a token's type per route (F-048), so the set-password call must carry
    // this one, not the code-step token it replaces.
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    message: string | null;
  }>()
);

export const verifyOtpFailure = createAction(
  '[Account Activation] Verify OTP Failure',
  props<{ error: string }>()
);

export const resendOtp = createAction('[Account Activation] Resend OTP');

export const resendOtpSuccess = createAction(
  '[Account Activation] Resend OTP Success',
  props<{
    activationToken: string | null;
    tokenType: string | null;
    nextStep: string | null;
    loginMethod: string | null;
    expiresIn: number | null;
    expiresAt: string | null;
    message: string | null;
  }>()
);

export const resendOtpFailure = createAction(
  '[Account Activation] Resend OTP Failure',
  props<{ error: string }>()
);

export const setPassword = createAction(
  '[Account Activation] Set Password',
  props<{ password: string }>()
);

export const setPasswordSuccess = createAction(
  '[Account Activation] Set Password Success',
  props<{
    accessToken: string | null;
    refreshToken: string | null;
    nextStep: string | null;
  }>()
);

export const setPasswordFailure = createAction(
  '[Account Activation] Set Password Failure',
  props<{ error: string }>()
);

export const reset = createAction('[Account Activation] Reset');

export const setLoading = createAction(
  '[Account Activation] Set Loading',
  props<{ loading: boolean }>()
);

export const setError = createAction(
  '[Account Activation] Set Error',
  props<{ error: string | null }>()
);
